import styled from 'styled-components';
import { breakpoint, ContentSpacing } from '@estee/elc-base-theme';
import { Heading2 } from '@estee/elc-typography';
import { accordionHeaderBorderTheme, panelTheme } from '../theme/default-theme';

interface IAccordion {
    isOpen: boolean;
}
interface IPanel {
    className: string;
}
const Panel = styled.div.attrs<IPanel, IPanel>({
    className: 'elc-panel'
})`
    ${panelTheme};
    padding: ${ContentSpacing.space8};
    ${breakpoint('desktop')`
        padding: ${ContentSpacing.space12};
    `};
`;

export const AccordionLightStyle = styled(Panel)`
    border: none;
    padding: 0;
`;

export const AccordionStyle = styled(AccordionLightStyle)`
    ${breakpoint('desktop')`
        border: 1px solid;
        border-radius: 4px;
        padding: ${ContentSpacing.space12};
        ${accordionHeaderBorderTheme};
    `};
`;

export const Header = styled.div<IAccordion & React.HTMLProps<HTMLElement>>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: inherit;
    cursor: pointer;
`;

export const HeaderLabel = styled(Heading2)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    cursor: pointer;
    margin: 0;
`;
